var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64.042px",
    height: "47.39px",
    viewBox: "0 0 64.042 47.39",
    enableBackground: "new 0 0 64.042 47.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#314584",
    d: "M59.389,0H4.653C2.088,0.004,0.004,2.087,0,4.651v38.088c0.004,2.563,2.088,4.646,4.652,4.65h54.736 c2.566-0.004,4.648-2.087,4.652-4.65V4.651C64.038,2.087,61.956,0.004,59.389,0z M62.182,42.739 c-0.004,1.527-1.264,2.787-2.793,2.79L4.653,45.528c-1.529-0.002-2.789-1.262-2.791-2.789V13.323 c0.002-1.529,1.262-2.788,2.791-2.791h54.736c1.529,0.003,2.787,1.261,2.793,2.789L62.18,42.739H62.182z M62.182,9.614 c-0.779-0.587-1.744-0.941-2.793-0.941H4.653c-1.049,0-2.014,0.354-2.791,0.941V4.651C1.864,3.122,3.124,1.863,4.653,1.86h54.736 c1.529,0.002,2.789,1.262,2.793,2.791V9.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3946",
    d: "M22.284,25.889l5.236-5.236c0.145-0.146,0.145-0.382,0-0.526l-0.791-0.789 c-0.145-0.145-0.381-0.145-0.525,0l-6.281,6.281c-0.145,0.146-0.145,0.381,0,0.525l0.596,0.597 c0.012,0.015,0.018,0.031,0.029,0.044l6.281,6.281c0.146,0.146,0.381,0.146,0.527,0l0.789-0.79c0.145-0.145,0.145-0.381,0-0.526 L22.284,25.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3946",
    d: "M38.506,19.801c-0.143-0.145-0.381-0.145-0.525,0l-0.789,0.789c-0.145,0.145-0.145,0.381,0,0.526 l5.234,5.234l-5.4,5.398c-0.145,0.145-0.145,0.382,0,0.526l0.789,0.79c0.145,0.146,0.381,0.146,0.527,0l6.281-6.282 c0.008-0.008,0.012-0.02,0.02-0.028l0.145-0.146c0.145-0.144,0.145-0.382,0-0.525L38.506,19.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3946",
    d: "M34.813,20.161l-1.074-0.305c-0.195-0.056-0.402,0.06-0.459,0.256l-3.07,10.818 c-0.057,0.197,0.059,0.404,0.256,0.46l1.074,0.306c0.195,0.056,0.404-0.06,0.459-0.257l3.07-10.818 C35.125,20.424,35.01,20.217,34.813,20.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D49",
    d: "M47.59,4.162h-3.418c-0.205,0-0.371,0.167-0.371,0.373v1.117c0,0.204,0.166,0.372,0.371,0.372h3.418 c0.207,0,0.373-0.168,0.373-0.372V4.535C47.963,4.33,47.797,4.162,47.59,4.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D49",
    d: "M53.055,4.163h-3.42c-0.203,0-0.371,0.167-0.371,0.372V5.65c0,0.204,0.168,0.372,0.371,0.372h3.42 c0.205,0,0.373-0.168,0.373-0.372V4.535C53.428,4.33,53.26,4.163,53.055,4.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D49",
    d: "M58.518,4.162H55.1c-0.205,0-0.371,0.167-0.371,0.371v1.118c0,0.204,0.166,0.372,0.371,0.372h3.418 c0.205,0,0.373-0.168,0.373-0.372V4.533C58.891,4.33,58.723,4.162,58.518,4.162z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon2);
export default __webpack_public_path__ + "static/media/service-icon2.7df69eea1b5e1448a284e81330c082fa.svg";
export { ForwardRef as ReactComponent };